export default {
      id: "sms-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite-46b249.svg#sms-usage",
      toString: function () {
        return this.url;
      }
    }